import * as api from "app/api/lossLimitsApi";
import { fetchUser } from "app/api/userApi";
import { LossLimitsType } from "app/types/userType";
const lossLimitsModel = {
  state: {
    lossLimitOneDay: 0,
    lossLimitSevenDays: 0,
    lossLimitThirtyDays: 0,
    selectedLossLimits: "lossLimitThirtyDays",
    isSubmittingLossLimit: false,
    errorMessage: "",
    showLossLimitsModal: false,
    username: "",
    isLossLimitSet: false,
  },
  reducers: {
    updateSelectedLossLimit(state: Record<string, any>, payload: number): any {
      const selectedKey = state.selectedLossLimits;
      if (state.hasOwnProperty(selectedKey)) {
        state[selectedKey] = payload;
      }
      return { ...state };
    },
    toggleLossLimitsModal(
      state: Record<string, any>,
      payload: { showLossLimitsModal: boolean; username: string }
    ): any {
      return {
        ...state,
        showLossLimitsModal: payload.showLossLimitsModal,
        username: payload.username,
        isLossLimitSet: false,
      };
    },
    hideLossLimitsModal(state: Record<string, any>): any {
      return {
        ...state,
        showLossLimitsModal: false,
        username: state.username,
        isLossLimitSet: false,
      };
    },
    setErrorMessage(state: Record<string, any>, payload: string): any {
      return { ...state, errorMessage: payload };
    },
    setSelectedLossLimits(state: Record<string, any>, payload: string): any {
      return { ...state, selectedLossLimits: payload };
    },
    setIsLossLimitSet(state: Record<string, any>, payload: boolean): any {
      return { ...state, isLossLimitSet: payload };
    },
    setLossLimitOneDay(state: Record<string, any>, payload: number): any {
      return { ...state, lossLimitOneDay: payload };
    },
    setLossLimitSevenDays(state: Record<string, any>, payload: number): any {
      return { ...state, lossLimitSevenDays: payload };
    },
    setLossLimitThirtyDays(state: Record<string, any>, payload: number): any {
      return { ...state, lossLimitThirtyDays: payload };
    },
    resetLimits(state: Record<string, any>): any {
      // Reset all loss limits to 0
      return {
        ...state,
        lossLimitOneDay: 0,
        lossLimitSevenDays: 0,
        lossLimitThirtyDays: 0,
      };
    },
    setSubmittingLossLimit(state: Record<string, any>, payload: boolean): any {
      return { ...state, isSubmittingLossLimit: payload };
    },
  },
  effects: {
    async setUpdateLossLimitsPrompt(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      api
        .updateLossLimitsPrompt(rootState.lossLimitsModel.username)
        .then(resp => {
          console.log("Loss limits prompt updated successfully:", resp);
          // Call fetchUser after the updateLossLimitsPrompt is successful
          return fetchUser();
        })
        .catch(error => {
          console.error("Error updating loss limits prompt:", error);
        });
    },
    async getLossLimits(): Promise<any> {
      api
        .fetchLossLimits()
        .then((resp: LossLimitsType) => {
          if (resp) {
            this.setLossLimitOneDay(resp.lossLimitOneDay ?? 0);
            this.setLossLimitSevenDays(resp.lossLimitSevenDays ?? 0);
            this.setLossLimitThirtyDays(resp.lossLimitThirtyDays ?? 0);
          }
        })
        .catch(error => {
          console.log("getLossLimits error: ", error);
        });
    },
    async submitLossLimit(
      payload: Record<string, any>,
      rootState: Record<string, any>
    ): Promise<any> {
      this.setSubmittingLossLimit(true);
      // if value is 0, set it to null
      // this is an existing API requirement
      const preprocessLossLimit = (value: number | null): number | null => {
        return value === 0 ? null : value;
      };

      const { lossLimitOneDay, lossLimitSevenDays, lossLimitThirtyDays } =
        rootState.lossLimitsModel;

      api
        .createLossLimits({
          lossLimitOneDay: preprocessLossLimit(lossLimitOneDay),
          lossLimitSevenDays: preprocessLossLimit(lossLimitSevenDays),
          lossLimitThirtyDays: preprocessLossLimit(lossLimitThirtyDays),
        })
        .then((resp: LossLimitsType) => {
          console.log("resp: ", resp);
          // update store with loss limits stored on API
          this.getLossLimits();
          this.setSubmittingLossLimit(false);
          this.setIsLossLimitSet(true);
          this.setErrorMessage("");
          return fetchUser();
        })
        .catch(error => {
          // handle error message
          this.setSubmittingLossLimit(false);
          this.setIsLossLimitSet(false);
          const errors = error.response.data.errors;
          const errorMessage = errors
            .map(
              (err: any) =>
                `${err.field || "Unknown Field"} - ${
                  err.messages?.[0] || "Unknown Error"
                }`
            )
            .join(" ");

          this.setErrorMessage(errorMessage);
          // update store with loss limits stored on API
          this.getLossLimits();
        });
    },
  },
};
export default lossLimitsModel;
